import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onActivated, onMounted, ref } from "vue";
import router from "@/router";
import { useUserStore } from "@/stores/userStore";
import {
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  RankCode,
  RouterName,
  ShowToastMessage,
  RouterNameType,
} from "@/types";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";
import Switch from "@/components/shared/Switch.vue";
import MyInfoRow from "@/components/mypage/MyInfoRow.vue";
import { useServiceStore } from "@/stores/serviceStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL } from "@/types";
import { ShowErrorModal } from "@/types";
import { ISignupField } from "@/domain/entities/serviceInfo/serviceInfo.types";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "MyInfo",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;
const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const serviceStore = useServiceStore();
const userStore = useUserStore();
const userInfo = computed(() => userStore.userInfo);
const rankCode = computed(() => userInfo.value?.rankCode ?? RankCode.NONE);
const userInfoFields = computed(
  () => serviceStore.getUserInfoByUseRankCode(rankCode.value)?.fields ?? []
);
const noticeConfig = ref(false);
const shouldHaveNoticeConfig = computed(() =>
  userInfoFields.value.find((field) => field.key === "JOIN.MAJOR_NOTICE_YN")
);

const myInfoContainer = ref<HTMLElement>();

const shouldShowMyInfoRow = (field: ISignupField) => {
  return (
    field.key !== "JOIN.BP_NAME" &&
    field.key !== "JOIN.MAJOR_NOTICE_YN" &&
    !field.excludeUserInfoYn &&
    getFieldValue(field)
  );
};

const getFieldValue = (field: ISignupField) => {
  switch (field.key) {
    case "JOIN.CLIENT_COMPANY":
      return userInfo.value?.bpName
        ? userInfo.value.bpName
        : userInfo.value?.clientName;
    case "JOIN.PASSWORD":
      return "*";
    case "JOIN.HOME_ADDRESS":
      return `${userInfo.value?.address?.roadAddress ?? ""} <br/> ${
        userInfo.value?.address?.detailAddress ?? ""
      }`;
    case "JOIN.MEMBER_ALIAS":
      return `${userInfo.value?.alias ?? ""}`;
    case "JOIN.WORK_TIME":
      return `${userInfo.value?.workTimeName ?? ""}`;
    default:
      return userInfo.value?.[field.inputFields?.[0] ?? ""];
  }
};

const goToMyInfoAuth = (nextPageName: RouterNameType) => {
  router.push({
    name: RouterName.MyInfoAuth,
    query: { nextPageName },
  });
};

const setNoticeConfig = async (receiveNotice: boolean) => {
  const noticeConfigResult = await userStore.setNoticeConfig(receiveNotice);
  if (!noticeConfigResult.isSuccess) {
    showToastMessage("알림 설정 중 오류가 발생하였습니다.", 3000, 350);
    noticeConfig.value = !receiveNotice;
  }
  noticeConfig.value = noticeConfigResult.data?.receiveNotice ?? false;
};

/** 유저 정보 가져오기 */
const getUserInfo = async () => {
  const userInfoResult = await userStore.getUserInfo();
  if (!userInfoResult.isSuccess) {
    showErrorModal(
      "사용자 정보 오류",
      userInfoResult.errorMessage,
      userInfoResult.resultCode,
      userInfoResult.errorTime
    );
  }
};

onMounted(async () => {
  if (!userInfo.value) {
    await getUserInfo();
  }
  const noticeConfigResult = await userStore.getNoticeConfig();
  noticeConfig.value = noticeConfigResult.data?.receiveNotice ?? false;
});

onActivated(() => {
  getUserInfo();
});

const __returned__ = { showToastMessage, showErrorModal, serviceStore, userStore, userInfo, rankCode, userInfoFields, noticeConfig, shouldHaveNoticeConfig, myInfoContainer, shouldShowMyInfoRow, getFieldValue, goToMyInfoAuth, setNoticeConfig, getUserInfo, get RouterName() { return RouterName }, NavigationBar, Page, Switch, MyInfoRow, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})